/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Enumeration for message senders.
 */
export enum MessageSender {
  User = 'user',
  System = 'system',
  Assistant = 'assistant'
}

